import { Box, Stack, Typography, type SxProps, type Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import logoMark from '@/assets/nb-logo-mark-192.png';

type BrandLogoProps = {
  compact?: boolean;
  markSize?: number;
  subtitle?: string;
  sx?: SxProps<Theme>;
};

export function BrandLogo({
  compact = false,
  markSize = compact ? 34 : 42,
  subtitle = 'Cloud hospitality management',
  sx,
}: BrandLogoProps) {
  return (
    <Stack
      direction="row"
      spacing={1.25}
      sx={[
        { alignItems: 'center', minWidth: 0 },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      <Box
        component="img"
        src={logoMark}
        alt=""
        aria-hidden="true"
        sx={(theme) => ({
          width: markSize,
          height: markSize,
          flex: '0 0 auto',
          objectFit: 'contain',
          border: 1,
          borderColor: 'divider',
          borderRadius: 1.5,
          bgcolor: 'common.white',
          filter:
            theme.palette.mode === 'dark'
              ? `drop-shadow(0 8px 18px ${alpha(theme.palette.common.black, 0.28)})`
              : 'none',
        })}
      />

      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant={compact ? 'h3' : 'h2'}
          component="p"
          sx={(theme) => ({
            lineHeight: 1,
            color: 'text.primary',
            textShadow:
              theme.palette.mode === 'dark'
                ? `0 1px 0 ${alpha(theme.palette.common.black, 0.2)}`
                : 'none',
          })}
        >
          Nang Book
        </Typography>
        {subtitle && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: 'block', mt: 0.3, whiteSpace: 'nowrap' }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
    </Stack>
  );
}
